// Import packages
import {connect} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import moment from "moment/moment";
import html2pdf from "html2pdf.js";

import "./download-room-timeline.scss";
import "../../../assets/styles/dataDisplay/template.scss"

import {TemplateInfoLogo, TemplateLogo, TemplateMarkIcon, TemplateTimeIcon} from "../../../assets/images";


//import components
import {LinkButton} from "../../../components/buttons/buttons";
import {InputGroup} from "../../../components/uiElements/inputGroup";

//import utils
import {WEEKDAY_TYPES, WORKOUT_ROOM_CONST, WORKOUT_TYPE_CONST} from "../../../constants/constsTypes";
import {GetAllGroupWorkoutTimelines} from "../../../redux/actions";
import {mapStateToProps} from "../../../redux/mapStateToProps";
import {localTime, makeUTCTime} from "../../../utils/dateHelper";
import {trainerIds} from "../../../constants/constIds";


const roomTypeOptions = Object.values(WORKOUT_ROOM_CONST).map(room => ({
    id: room.key,
    name: room.title
}));


function DownloadRoomTimeline(props) {
    const {timeline} = props;
    const contentRef = useRef();

    const [room, setRoom] = useState(WORKOUT_ROOM_CONST["1"].key);
    // const [scale, setScale] = useState('1');
    const [workoutTimeLine, setWorkoutTimeLine] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        timeline && processTimeLine()
    }, [timeline, room]);

    async function processTimeLine() {
        const workoutTimeLine = {}
        Object.keys(WEEKDAY_TYPES).forEach(key => {
            workoutTimeLine[key] = room === WORKOUT_ROOM_CONST.Other.key ? timeline?.filter(item => item.weekday === key && !item?.workout?.is_hidden
                    && (!item.room || item.include_in_other)) :
                timeline?.filter(item => item.weekday === key && !item?.workout?.is_hidden
                    && item.room === room);
        })
        console.log('workoutTimeLine', workoutTimeLine);
        setWorkoutTimeLine(workoutTimeLine)
    }

    function getRoomValue({value}) {
        setRoom(value)
    }

    /*    function getScaleValue({value}) {
            setScale(value)
        }*/

    function handleDownloadPdf() {
        const element = contentRef.current;
        const options = {
            margin: 0,
            filename: `room-${room}-timeline.pdf`,
            image: {type: 'jpeg', quality: 0.99},
            html2canvas: {
                scale: 2,
                width: 1754,
                height: 1240,
                // width: 3508,        // Match  300 DPI width
                // height: 2480,
                logging: false,
                useCORS: true
            },

            jsPDF: {
                compress: false,
                compressPdf: false,
                format: [1754, 1240],
                // format: [3508, 2480],
                unit: 'px',
                hotfixes: ['px_scaling'],
                orientation: 'landscape'
            },
        };

        html2pdf().set(options).from(element).save();
    }

    return <div className={'timeline-downloader-wrapper'}>
        <div className={'visible-part'}>
            <div className={'title'}> Ընտրել սրահ</div>
            <InputGroup inputType="selectCustom"
                        placeholder="Ընտրել սրահ"
                        name="room"
                        showSearch={false}
                        value={room}
                        required={true}
                        onChange={getRoomValue}
                        options={roomTypeOptions}/>
            {/*<InputGroup inputType="input"
                        number={true}
                        placeholder="scale"
                        name="scale"
                        minValue={1}
                        showSearch={false}
                        wrapperClassName="scale-wrapper"
                        value={scale}
                        onChange={getScaleValue}/>*/}

            <LinkButton title={"Download Room Pdf"}
                        disabled={!workoutTimeLine}
                        loadingWithTitle={true}
                        loading={loading}
                        cb={handleDownloadPdf}
            />
        </div>
        {/*  <div className={'preview_window'}>
        </div>*/}
        <div className={`a4_page ${loading ? 'visible' : ''}`} ref={contentRef}>
            <div className="template">
                <div className="template-header">
                    <div className={'template-header-title'}>
                        <img src={TemplateLogo} alt="icon"/>
                        <div>
                            <h1>ԽՄԲԱՅԻՆ ՄԱՐԶՈՒՄՆԵՐԻ ԳՐԱՖԻԿ</h1>
                            <h2>GROUP WORKOUTS SCHEDULE</h2>
                        </div>
                    </div>

                    <span className="hall-number">&nbsp;{WORKOUT_ROOM_CONST[room]?.label || ""}</span>
                </div>

                <table className="template_block">
                    <tbody>
                    {!!workoutTimeLine && Object.values(WEEKDAY_TYPES)?.map((weekday) => {
                            const weekTimelineList = workoutTimeLine[weekday.key];
                            return <tr key={weekday.key} className="template-row">
                                <td className="template-weekday-column"
                                    style={{backgroundColor: weekday.color}}>
                                    <span className="template-day-label">{weekday.shortName}</span>
                                    <strong className="template-day-number">{weekday.shortNameEn}</strong>
                                </td>

                                <td className="template-classes-container">
                                    {weekday.key === WEEKDAY_TYPES.Monday.key && <div className={'first_row_time_header'}>

                                    </div>}
                                    {weekTimelineList?.length ? (
                                        weekTimelineList?.slice(0, 12)?.map((item) => {
                                            const weekAddition = weekday.index;
                                            const endTimeWeekAddition = weekAddition + (makeUTCTime(item.end_time).hour() === 0 ? 1 : 0)
                                            const cancellationDate = item?.workout?.workout_cancellations?.find(c => {
                                                return makeUTCTime(item.start_time).day(weekAddition).valueOf()
                                                    < moment(c.date).valueOf() && moment(c.date).valueOf() <
                                                    makeUTCTime(item.end_time).day(endTimeWeekAddition).valueOf()
                                            })
                                            if (cancellationDate) return null;
                                            const trainers = item?.trainers?.length ? item?.trainers : item?.workout?.workout_trainers;
                                            const time = localTime(item?.start_time);
                                            return <div className="template-class-card" key={item.id}>
                                                <div className="template-time">
                                                    {time}
                                                </div>
                                                <div className="template-name-image">
                                                    {item?.workout?.use_name ?
                                                        <div
                                                            className={`workout_name ${item?.workout?.title?.length > 6 ? 'small' : ''}`}
                                                            style={{
                                                                color: item?.workout?.title_color ? item?.workout?.title_color : 'black',
                                                                fontSize: item?.workout?.title_size ? item?.workout?.title_size + 'px' : '',
                                                            }}>
                                                            {item?.workout?.title}
                                                        </div>
                                                        :
                                                        <img src={item?.workout?.image_url}
                                                            /*    style={scale ? {
                                                                    transform: `scale(${scale},${scale})`,
                                                                } : undefined}*/
                                                             alt={item?.workout?.title}/>
                                                    }

                                                </div>
                                                <div className="template-instructor-label">Instructor</div>
                                                <div className="template-instructor-name">{
                                                    trainers?.length ?
                                                        trainers?.map(t => {
                                                            const [firstName, lastName] = t?.name?.split(' ');
                                                            let name = `${firstName}${trainerIds?.includes(t.id) ? ` ${lastName?.slice(0, 3)}` : ''}`
                                                            return name
                                                        }).join('/')
                                                        : '-'}
                                                </div>
                                            </div>
                                        })
                                    ) : (
                                        <div className="template-empty-row"/>
                                    )}
                                </td>
                            </tr>
                        }
                    )}
                    </tbody>
                </table>

                <div className={'template_info_block'}>
                    <div className={'info_logo'}>
                        <img src={TemplateInfoLogo} alt="logo"/>
                    </div>
                    <div className={'mark_block'}>
                        <img src={TemplateMarkIcon} alt="icon"/>
                        <div className={'mark_text'}>
                        <span>
                            Մարզումից հետո բոլոր պարագաները
                        (մարզման գորգ, քաշեր այլն) պետք է
                        դրված լինեն իրենց համար նախատեսված
                        տեղերում
                        </span>
                            <span>
                              Please return all equipment to its designated
                        place after your workout (mats, weights and
                        other training accessories)
                        </span>
                        </div>
                    </div>
                    <div className={'mark_block second_block'}>
                        <img src={TemplateTimeIcon} alt="icon"/>
                        <div className={'mark_text'}>
                        <span>
                            Ցանկալի է ներկայանալ մարզմանը
                            նշված ժամից 5 րոպե շուտ
                        </span>
                            <span>
                            Please arrive 5 minutes before the
                            workout starts
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
}

const mapDispatchToProps = {
    GetAllGroupWorkoutTimelines,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadRoomTimeline);
